export default __webpack_public_path__ + "static/willow-be15afc071005d198a619070cc694e69.jpg";